// extracted by mini-css-extract-plugin
export default {"sliderContainer":"HeroSlider_sliderContainer__1C1Md","slide":"HeroSlider_slide__QVyI8"};